import { Link } from "react-router-dom";
import { FileText, KeyRound } from "lucide-react";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { useAuth } from "@/context/AuthContext";
import { fmtCurrency, fmtDateLong as fmtDate } from "@/lib/format";

const every = (m) => (m === 1 ? "al mese" : m === 12 ? "all'anno" : `ogni ${m} mesi`);
const nextDue = (f) => f.billed_until ? `pagato fino al ${fmtDate(f.billed_until)}`
  : f.start_date > new Date().toISOString().slice(0, 10) ? `da fatturare dal ${fmtDate(f.start_date)}` : "da fatturare (anticipato)";

export const QuoteContractPanel = ({ q, contract }) => {
  const { can } = useAuth();
  const recurring = q.lines.some((l) => l.recurrence && l.recurrence !== "una_tantum");
  if (!recurring) return null;
  if (!contract) return (
    <Panel className="p-4 text-sm text-slate-700" data-testid="quote-view-recurring">
      Contiene righe a canone: all'accettazione viene creato un contratto con fatturazione anticipata dal mese di attivazione
      {q.lines.some((l) => ["licenza", "anno"].includes(l.unit) && l.recurrence !== "una_tantum") ? " e la licenza del cliente per hosting/dominio" : ""}
      {" · "}{q.contract_months ? `durata ${q.contract_months} mesi` : "senza scadenza"}. I canoni non vanno in ordine.
    </Panel>);
  return (
    <Panel className="p-5" data-testid="quote-contract-panel">
      <div className="flex flex-wrap items-center justify-between gap-2"><SectionLabel>Contratto e canoni</SectionLabel>
        <Link to={`/contratti/${contract.id}`} className="text-sm font-semibold text-brand-700 hover:underline" data-testid="quote-contract-link">{contract.number} · {contract.status}</Link></div>
      <ul className="mt-3 space-y-2">{contract.fees.map((f) => (
        <li key={f.id} className="flex flex-wrap items-center justify-between gap-2 rounded-control border border-slate-100 px-3 py-2 text-sm" data-testid={`quote-contract-fee-${f.id}`}>
          <span className="font-medium text-ink">{f.description}</span>
          <span className="flex flex-wrap items-center gap-3 text-xs text-slate-600">
            <span>{fmtCurrency(f.amount)} {every(f.custom_months)} · dal {fmtDate(f.start_date)}</span>
            <span className={f.billed_until ? "" : "font-semibold text-orange-700"}>{f.status === "cessato" ? "cessato" : nextDue(f)}</span>
            {f.license && <Link to={`/licenze?open=${f.license.id}`} className="inline-flex items-center gap-1 text-brand-700 hover:underline" data-testid={`quote-contract-fee-license-${f.id}`}><KeyRound className="h-3 w-3" />{f.license.code}{f.license.end_date ? ` · scad. ${fmtDate(f.license.end_date)}` : ""}</Link>}
          </span>
        </li>))}</ul>
      {can("billing:read") && <Link to="/da-fatturare" className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-brand-700 hover:underline" data-testid="quote-contract-billing-link"><FileText className="h-3.5 w-3.5" />Vai a Da fatturare</Link>}
    </Panel>
  );
};
